// avstemming-receivables-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avbk.assess.notAssessed': 'Ikke vurdert',
  'avbk.assess.expectedPaid': 'OK – forventes innbetalt',
  'avbk.paidAfterPeriod': 'Innbetalt etter periodedato',
  'avbk.assess.remind': 'Skal purres',
  'avbk.assess.toCollection': 'Sendes til inkasso',
  'avbk.assess.paymentPlan': 'Betalingsavtale foreligger',
  'avbk.assess.matchPayment': 'Skal matches mot innbetaling',
  'avbk.assess.disputed': 'Omtvistet',
  'avbk.assess.issueCreditNote': 'Kreditnota skal utstedes',
  'avbk.assess.partialLoss': 'Delvis tapsrisiko',
  'avbk.assess.fullLoss': 'Full tapsrisiko',
  'avbk.assess.writeDown': 'Nedskrivning vurderes',
  'avbk.assess.writeOff': 'Tapsføres',
  'avbk.assess.awaitingClient': 'Avventer klienten',
  'avbk.assess.awaitingDocs': 'Avventer dokumentasjon',
  'avbk.followUpNext': 'Følges opp neste periode',
  'avbk.risk.high': 'Høy',
  'avbk.risk.medium': 'Middels',
  'avbk.risk.low': 'Lav',
  'avbk.risk.unknown': 'Ukjent',
  'avbk.quick.needsAssessment': 'Krever vurdering',
  'avbk.quick.allOpen': 'Alle åpne',
  'avbk.quick.overdue': 'Forfalt',
  'avbk.quick.over90': 'Over 90 dager',
  'avbk.quick.negative': 'Negative saldoer',
  'avbk.quick.creditNotes': 'Kreditnotaer',
  'avbk.possibleDuplicates': 'Mulige duplikater',
  'avbk.quick.collection': 'Inkasso',
  'avbk.lossRisk': 'Tapsrisiko',
  'avbk.quick.missingDoc': 'Mangler dokument',
  'avbk.assessedDone': 'Ferdig vurdert',
  'avbk.daysLabel.na': 'Ikke relevant',
  'avbk.notOverdue': 'Ikke forfalt',
  'avbk.overdueBy': 'Forfalt med {days} dager',
  'avbk.flags.none': 'Ingen',
  'avbk.flags.more': '+{count} flere',
  'avbk.page.noAccount': 'Området har ingen avstemmingskonto i denne perioden.',
  'avbk.nav.overview': 'Oversikt',
  'avbk.nav.openItems': 'Åpne poster',
  'avbk.nav.customerRisk': 'Kunde- og kredittrisiko',
  'avbk.nav.controls': 'Kontroller',
  'avbk.nav.conclusion': 'Konklusjon',
  'avbk.nav.blocked': 'Blokkert',
  'avbk.nav.ready': 'Klar',
  'avbk.areaLabel': 'Kundefordringer',
  'avbk.page.title': 'Kundereskontro og åpne poster',
  'avbk.page.resetFilters': 'Nullstill filtre',
  'avbk.page.customerFilter': 'Kunde: {name}',
  'avbk.page.showAllCustomers': 'Vis alle kunder',
  'avbk.page.accountFilter': 'Kontrollkonto: {account}',
  'avbk.page.showAllAccounts': 'Vis alle kontrollkontoer',
  'avbk.page.ageFilter': 'Aldersgruppe: {bucket}',
  'avbk.page.showAllAges': 'Vis alle aldersgrupper',
  'avbk.customer': 'Kunde',
  'avbk.page.docNo': 'Dok.nr',
  'avbk.type': 'Type',
  'avbk.invoiceDate': 'Fakturadato',
  'avbk.dueShort': 'Forfall',
  'avbk.page.original': 'Opprinnelig',
  'avbk.openAmount': 'Åpent beløp',
  'avbk.daysOverdue': 'Dager forfalt',
  'avbk.collection': 'Innfordring',
  'avbk.alert': 'Varsel',
  'avbk.assessment': 'Vurdering',
  'avbk.seeAssessment': 'Se vurdering',
  'avbk.assess': 'Vurder',
  'avbk.page.noMatch': 'Ingen kundeposter passer med filtrene.',
  'avbk.page.noOpenItems': 'Ingen åpne kundeposter i denne perioden. Har klienten ingen utestående fakturaer, er det ingen reskontro å avstemme.',
  'avbk.header.controlAccount': 'Kontrollkonto {accounts}',
  'avbk.responsible': 'Ansvarlig {name}',
  'avbk.header.ledgerVsSubledger': '{area} – hovedbok mot reskontro',
  'avbk.header.noControlAccount': 'Ingen kontrollkonto i området',
  'avbk.header.ledgerMatches': 'Hovedbok og reskontro stemmer',
  'avbk.header.ledgerDiverges': 'Hovedbok og reskontro spriker',
  'avbk.header.noSubledgerAccount': 'Ingen kontrollkonto med reskontro',
  'avbk.header.itemsNeedAssessment': '{count} reskontroposter krever vurdering før avstemmingen kan sendes til kontroll.',
  'avbk.header.noItemsLeft': 'Ingen reskontroposter står igjen til vurdering.',
  'avbk.balance.title': 'Automatisk saldoavstemming',
  'avbk.balance.computedAt': 'Reskontroen er regnet per {date}',
  'avbk.balance.subsequent': 'Etterfølgende hendelser kontrollert til og med {date}',
  'avbk.balance.booked': 'Bokført saldo, kontrollkonto med reskontro',
  'avbk.balance.sumOpen': 'Sum åpne poster i kundereskontroen',
  'avbk.difference': 'Differanse',
  'avbk.balance.noSubledger': 'Ingen av områdets kontoer er kundefordringskontoen appen fører salg mot ({account}). Da finnes ingen reskontro å sammenlikne saldoen med, og differansen må forklares på kontoen selv.',
  'avbk.balance.mismatch': 'Kontrollkontoen stemmer ikke med reskontroen. Differansen må forklares før området kan avstemmes — se direkteføringene lenger ned.',
  'avbk.balance.openingBalance': 'Saldo forrige periode',
  'avbk.balance.change': 'Endring i perioden',
  'avbk.balance.openInvoices': 'Åpne fakturaer',
  'avbk.balance.openCreditNotes': 'Åpne kreditnotaer',
  'avbk.balance.totalItems': 'Poster totalt i kontrollen',
  'avbk.balance.customersWithBalance': 'Kunder med saldo',
  'avbk.accounts.title': 'Kontrollkontoer',
  'avbk.accounts.empty': 'Ingen balansekontoer er knyttet til kundefordringer i denne perioden. Uten en kontrollkonto finnes det ingen bokført saldo å sammenlikne reskontroen med.',
  'avbk.accounts.controlAccount': 'Kontrollkonto',
  'avbk.accounts.bookedBalance': 'Bokført saldo',
  'avbk.accounts.subledgerBalance': 'Reskontrosaldo',
  'avbk.status': 'Status',
  'avbk.noSubledger': 'Ingen reskontro',
  'avbk.accounts.deviation': 'Avvik',
  'avbk.matches': 'Stemmer',
  'avbk.accounts.open': 'Åpne konto',
  'avbk.control.ledgerVsSubledger': 'Hovedbok mot reskontro',
  'avbk.control.ledgerVsSubledgerHint': 'Bokført saldo sammenliknet med summen av de åpne postene per periodeslutt.',
  'avbk.control.old': 'Gamle poster over 90 dager',
  'avbk.control.oldHint': 'Åpne poster forfalt mer enn 90 dager.',
  'avbk.control.negative': 'Negative kundesaldoer',
  'avbk.control.negativeHint': 'Poster som står med et beløp kunden har til gode.',
  'avbk.control.affected': '{count} berørte poster',
  'avbk.control.duplicatesHint': 'Samme kunde, samme fakturadato og samme beløp.',
  'avbk.control.collectionNotices': 'Inkassovarsler sendt',
  'avbk.control.collectionNoticesHint': 'Poster der klienten har sendt inkassovarsel fra Plumme.',
  'avbk.control.lossToAssess': 'Tapsrisiko til vurdering',
  'avbk.control.lossToAssessHint': 'Poster forfalt over 90 dager eller eskalert til inkassovarsel. Nedskrivning avgjøres av regnskapsfører.',
  'avbk.control.missingDoc': 'Manglende fakturadokument',
  'avbk.control.missingDocHint': 'Poster uten lagret fakturadokument.',
  'avbk.control.over30': 'Forfalte poster over 30 dager',
  'avbk.control.over30Hint': 'Åpne poster forfalt mellom 31 og 90 dager.',
  'avbk.control.partPaid': 'Delbetalt, men fortsatt åpen',
  'avbk.control.partPaidHint': 'Poster med registrert innbetaling som likevel står åpne.',
  'avbk.control.unmatchedCredit': 'Kreditnotaer som ikke er utlignet',
  'avbk.control.unmatchedCreditHint': 'Åpne kreditnotaer som kan motregnes mot fakturaer.',
  'avbk.control.creditAfter': 'Kreditnota etter periodedato',
  'avbk.control.creditAfterHint': 'Kreditnota utstedt etter periodedato på en faktura som var åpen. Kan være et periodiserings- eller verdsettelsesforhold.',
  'avbk.control.paidAfterHint': 'Åpne poster per periodedato som er innbetalt etterpå — normalt positiv dokumentasjon.',
  'avbk.control.directPosted': 'Direkteført på kontrollkonto',
  'avbk.control.directPostedHint': 'Hovedbokslinjer på kontrollkontoene som ikke kommer fra en faktura eller en innbetaling.',
  'avbk.overCreditLimit': 'Kunder over kredittgrense',
  'avbk.control.overLimitHint': 'Kunder med åpen saldo over kredittgrensen på kundekortet.',
  'avbk.control.title': 'Kontrollkort',
  'avbk.control.summary': 'Automatiske kontroller kjørt: {checks} av {checks} · Kontroller med funn: {findings} · Poster som krever manuell vurdering: {unassessed}',
  'avbk.control.hide': 'Skjul',
  'avbk.control.showAll': 'Vis alle automatiske kontroller',
  'avbk.control.activeFilter': 'Aktivt filter: {label} · {count} poster',
  'avbk.control.removeFilter': 'Fjern filter',
  'avbk.control.creditNote': 'Faktura {invoice} ({customer}) var åpen per {date}. Kreditnota {credit} ble utstedt {creditDate} — mulig periodiserings- eller verdsettelsesforhold. Plumme avgjør ikke automatisk hvilken periode kreditnotaen tilhører.',
  'avbk.aging.title': 'Aldersfordeling (dager forfalt)',
  'avbk.aging.empty': 'Ingen åpne kundeposter per periodeslutt — ingenting å fordele på alder.',
  'avbk.aging.note': 'Regnet fra forfallsdatoen, ikke fra fakturadatoen.',
  'avbk.aging.age': 'Alder',
  'avbk.aging.itemCount': 'Antall poster',
  'avbk.aging.share': 'Andel',
  'avbk.aging.sumOpen': 'Sum åpne poster',
  'avbk.risk.concentrationTitle': 'Kunde- og konsentrasjonsrisiko',
  'avbk.risk.concentrationEmpty': 'Ingen kunder har åpen saldo per periodeslutt. Konsentrasjonsrisiko måles av de åpne postene, så uten dem er det ingen fordeling å vurdere.',
  'avbk.risk.largestBalance': 'Største kundesaldo',
  'avbk.risk.topFive': 'Topp 5 kunder av total saldo',
  'avbk.risk.topFiveHint': 'Hvor stor del av den åpne saldoen som ligger hos de fem største kundene.',
  'avbk.risk.noLimitSet': 'Ingen grense satt',
  'avbk.risk.noLimitHint': 'Kredittgrensen settes på kundekortet. Uten grense finnes ingen grense å måle mot.',
  'avbk.risk.multipleOld': 'Kunder med flere gamle poster',
  'avbk.risk.multipleOldHint': 'Kunder med mer enn én post forfalt over 90 dager.',
  'avbk.risk.withNotice': 'Kunder med inkassovarsel',
  'avbk.risk.highRisk': 'Kunder med høy risiko',
  'avbk.risk.totalOpen': 'Samlet åpen saldo',
  'avbk.risk.overdueBalance': 'Forfalt saldo',
  'avbk.risk.oldest': 'Eldste post',
  'avbk.risk.creditLimit': 'Kredittgrense',
  'avbk.risk.utilised': 'Utnyttet',
  'avbk.collectionStatus': 'Innfordringsstatus',
  'avbk.risk.risk': 'Risiko',
  'avbk.risk.noLimitNote': 'Ingen av kundene har kredittgrense på kundekortet. Settes den der, måles den åpne saldoen mot den her.',
  'avbk.loss.title': 'Tapsrisiko og verdsettelse',
  'avbk.loss.intro': 'Plumme har identifisert forhold som kan indikere tapsrisiko. Regnskapsfører må gjøre og dokumentere den faglige vurderingen — systemet avgjør ikke nedskrivning eller tapsføring automatisk, og fører den ikke.',
  'avbk.loss.totalExposure': 'Samlet saldo med tapsrisiko',
  'avbk.loss.assessedAmount': 'Vurdert tapsutsatt beløp',
  'avbk.loss.notDone': 'Ikke ferdig',
  'avbk.loss.assessedAmountHint': 'Summen av det byrået selv har vurdert som tapsutsatt, nedskrevet eller tapsført.',
  'avbk.loss.highRiskItems': 'Poster med høy risiko',
  'avbk.loss.none': 'Ingen poster med tapsrisiko i denne perioden.',
  'avbk.loss.invoice': 'Faktura',
  'avbk.loss.open': 'Åpent',
  'avbk.loss.proposed': 'Foreslått',
  'avbk.daysCount': '{days} dager',
  'avbk.direct.title': 'Direkteføringer på kontrollkonto',
  'avbk.direct.empty': 'Ingen hovedbokslinjer på kontrollkontoene kommer fra noe annet enn en faktura eller en innbetaling. Kontrollen er kjørt — den fant ingenting.',
  'avbk.direct.note': 'Postert direkte på kontrollkontoen uten faktura eller innbetaling. Slike linjer har ingen reskontropost, og forklarer ofte differansen mellom hovedbok og reskontro.',
  'avbk.direct.date': 'Dato',
  'avbk.direct.voucher': 'Bilag',
  'avbk.direct.account': 'Konto',
  'avbk.direct.text': 'Tekst',
  'avbk.direct.amount': 'Beløp',
  'avbk.direct.sum': 'Sum direkteført',
  'avbk.checks.title': 'Automatiske kontroller',
  'avbk.checks.note': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De sier hva den som krysser av bør ha sett på.',
  'avbk.checks.check': 'Kontroll',
  'avbk.checks.run': 'Kjøring',
  'avbk.checks.result': 'Resultat',
  'avbk.checks.ran': 'Kjørt',
  'avbk.checks.findingsCount': '{count} funn',
  'avbk.checks.noFindings': 'Ingen funn',
  'avbk.derived.old': 'Alle vesentlige gamle poster er vurdert',
  'avbk.derived.negative': 'Negative kundesaldoer er forklart',
  'avbk.derived.duplicates': 'Mulige duplikater er vurdert',
  'avbk.derived.unmatchedCredit': 'Kreditnotaer som ikke er utlignet er vurdert',
  'avbk.derived.partPaid': 'Delbetalte poster er undersøkt',
  'avbk.derived.collection': 'Inkassosaker er gjennomgått',
  'avbk.derived.lossRisk': 'Poster med tapsrisiko er vurdert',
  'avbk.derived.creditAfter': 'Kreditnotaer etter periodedato er vurdert',
  'avbk.derived.missingDoc': 'Poster uten fakturadokument er behandlet',
  'avbk.blocker.itemOne': '{count} reskontropost krever vurdering',
  'avbk.blocker.itemMany': '{count} reskontroposter krever vurdering',
  'avbk.blocker.diff': '{amount} av differansen mot reskontroen er uforklart',
  'avbk.blocker.lossOne': '{count} post med tapsrisiko er ikke vurdert',
  'avbk.blocker.lossMany': '{count} poster med tapsrisiko er ikke vurdert',
  'avbk.blocker.checkpointOne': '{count} kontrollpunkt gjenstår',
  'avbk.blocker.checkpointMany': '{count} kontrollpunkter gjenstår',
  'avbk.checklist.title': 'Faglig sjekkliste',
  'avbk.checklist.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avbk.checklist.none': 'Ingen kontrollpunkter er definert for kundefordringer i denne perioden.',
  'avbk.checklist.note': 'Punktene gjelder hele området. En avkryssing lagres på alle kontrollkontoene i perioden.',
  'avbk.checklist.groupItems': 'Poster som krever behandling',
  'avbk.checklist.countOf': '{done} av {total}',
  'avbk.checklist.handledOf': '{done} av {total} behandlet',
  'avbk.checklist.notApplicable': 'Ikke aktuelt denne perioden',
  'avbk.checklist.followsAssessments': 'Følger av vurderingene',
  'avbk.checklist.groupAssessments': 'Overordnede faglige vurderinger',
  'avbk.checklist.groupReady': 'Klarstilling',
  'avbk.checklist.performedBy': 'Utføres av {name}',
  'avbk.checklist.doneOfTotal': '{done} av {total} kontrollpunkter fullført',
  'avbk.conclusion.title': 'Konklusjon og godkjenning',
  'avbk.conclusion.label': 'Konklusjon',
  'avbk.conclusion.placeholder': 'Hva viser gjennomgangen av kundefordringene for denne perioden?',
  'avbk.savedAsReason': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avbk.conclusion.remainingRisk': 'Gjenstående risiko',
  'avbk.conclusion.nothingBlocking': 'Ingenting står igjen som hindrer at området sendes til kontroll.',
  'avbk.followup.title': 'Oppfølging neste periode',
  'avbk.followup.none': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'avbk.followup.badge': 'Følges opp',
  'avbk.followup.noAction': 'Ingen tiltak notert',
  'avbk.followup.due': 'Frist {date}',
  'avbk.followup.expectedPaid': 'Forventet innbetalt {date}',
  'avbk.followup.open': 'Åpne vurdering',
  'avbk.conclusion.send': 'Send området til kontroll',
  'avbk.conclusion.oneThingLeft': 'Én ting står igjen før området kan sendes.',
  'avbk.conclusion.thingsLeft': '{count} ting står igjen før området kan sendes.',
  'avbk.drawer.reasonOverdue': 'Fordringen er {days} dager forfalt',
  'avbk.drawer.reasonNotice': 'Klienten har sendt inkassovarsel',
  'avbk.drawer.reasonReminders': '{count} purringer er sendt',
  'avbk.drawer.reasonPaidAfter': 'Innbetalt {amount} etter periodedato',
  'avbk.drawer.reasonDuplicate': 'Mulig duplikat av {others}',
  'avbk.drawer.unknownOrgNo': 'Ukjent org.nr',
  'avbk.close': 'Lukk',
  'avbk.drawer.dueDate': 'Forfallsdato',
  'avbk.drawer.originalAmount': 'Opprinnelig beløp',
  'avbk.drawer.openAtPeriodEnd': 'Åpent per periodeslutt',
  'avbk.drawer.paidInPeriod': 'Innbetalt i perioden',
  'avbk.drawer.settledAfterDate': 'Åpen med {open} per periodeslutt · innbetalt {settled} den {date} — normalt positiv dokumentasjon på at fordringen var reell og innbetalbar.',
  'avbk.drawer.settledAfter': 'Åpen med {open} per periodeslutt · innbetalt {settled} — normalt positiv dokumentasjon på at fordringen var reell og innbetalbar.',
  'avbk.drawer.creditedAfter': 'Kreditnota {docNumber} på {amount} ble utstedt {date}, etter periodedato. Om den gjelder omsetning før periodedato er en faglig vurdering — Plumme avgjør den ikke.',
  'avbk.drawer.duplicateNote': 'Samme kunde, samme fakturadato og samme beløp som {others}. Det er et forslag til gjennomgang, ikke en konklusjon.',
  'avbk.drawer.noDocument': 'Posten har ikke noe lagret fakturadokument i Plumme.',
  'avbk.drawer.basis': 'Grunnlaget for vurderingen:',
  'avbk.drawer.expectedDate': 'Forventet innbetalingsdato',
  'avbk.drawer.expectedAmount': 'Forventet innbetalt beløp',
  'avbk.drawer.probability': 'Sannsynlighet for innbetaling',
  'avbk.drawer.proposedWriteDown': 'Foreslått nedskrivning',
  'avbk.drawer.proposedWriteOff': 'Foreslått tapsføring',
  'avbk.drawer.amountsNote': 'Beløpene er byråets forslag. Plumme fører ingen nedskrivning eller tapsføring av dem — de blir stående ved siden av fordringen til noen bokfører den.',
  'avbk.drawer.rationaleRequired': 'Begrunnelse (påkrevd)',
  'avbk.drawer.rationale': 'Begrunnelse',
  'avbk.drawer.rationalePlaceholder': 'Hva viser gjennomgangen av denne fordringen?',
  'avbk.drawer.action': 'Tiltak',
  'avbk.drawer.actionPlaceholder': 'F.eks. Følg opp inkassostatus',
  'avbk.drawer.followUpDue': 'Frist for oppfølging',
  'avbk.drawer.docsOnAccount': 'Dokumentasjon på kontrollkontoen',
  'avbk.drawer.needsComment': 'Denne vurderingen krever en begrunnelse.',
  'avbk.drawer.save': 'Lagre vurdering',
  'avbk.drawer.requestDocs': 'Be klienten om dokumentasjon',
});
